import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useUserCapabilities } from '@/hooks/use-user-capabilities'
import { UnauthorizedPage } from '@/components/auth/UnauthorizedPage'

// Layout route para /dashboard/$dashboardId/conversas/$channelInstanceUuid
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid',
)({
  component: function ConversasChannelLayout() {
    const { dashboardId } = Route.useParams()
    const { canAccessConversas, isLoading } = useUserCapabilities(dashboardId)

    if (isLoading) {
      return (
        <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
          <div className="text-muted-foreground">Carregando...</div>
        </div>
      )
    }

    if (!canAccessConversas()) {
      return <UnauthorizedPage />
    }

    return <Outlet />
  },
})
